<template>
  <a-spin :spinning="formOption.busy">
    <a-form
        ref="form"
        :form="form"
        :label-col="{ span: 12 }"
        :wrapper-col="{ span: 12 }"
    >

      <a-row :gutter="24">
        <a-col :span="24">
          <a-form-item label="关键词" :label-col="{ span: 4 }"
                       :wrapper-col="{ span: 20}">
            <a-input v-decorator="['keyWordsName',rules.keyWordsName ]" :maxLength="10"/>
          </a-form-item>
        </a-col>
      </a-row>

    </a-form>

    <a-space class="a-form-btn-box">
      <a-button @click="endEdit('cancelled')">取消</a-button>
      <a-button type="primary" @click="_save(false)">提交</a-button>
    </a-space>
  </a-spin>
</template>

<script>
import {formMixin} from "@/utils/FormMixin";
import {formatter as fmt} from "@/utils/form-formatter";
//通用代码api
import {loadBaseCodeData} from '@/services/baseCodeSource';

console.log(loadBaseCodeData)

//接口API
import {dataApi} from '@/services/question/keyWords';

// import roleTable from "@/pages/web/comm/userManage/detail/roleTable";
import {mapState} from "vuex";

// import XEUtils from "xe-utils";

/**
 * 加载规则
 */
function getRulesTemplate() {
  return {
    keyWordsName: {
      rules: [{required: true, whitespace: true, message: "请输入关键词"}]
    }
  };
}


/**
 * 加载数据之后执行的函数(新建表单也会执行)
 */
function afterLoad() {
  // //给子表赋值
  // this.$refs['roleTable'].loadData(entity.roleList);
  // this.editStatus = !!entity.userNo;//是否可编辑用户账号
  // this.createUserId = entity.createUserId;
  // this.createDate = entity.createDate;
}

/**
 * 新建表单数据 没有预设可以不写  预设的值可以在afterLoad之中调用到
 * 一般是用来写表单默认值 或者写不在表单中需要保存的值
 * @returns {Object}
 */
function newEntity() {
  return {}
}

/**
 * 加载数据
 * @param rowId 主键值
 * @returns {Promise}
 */
async function loadEntity(rowId) {
  let entity = await dataApi.getFormDetail(rowId);
  return fmt.formatFormLoad(entity);
}


/**
 * 加载基础数据
 */
async function loadBaseData() {
  // let menuData = await dataApi.getMenuList();
  // this.treeData = XEUtils.toArrayTree(menuData.data, {
  //   key: 'deptId',
  //   parentKey: 'parentId',
  //   children: 'children'
  // });
}


/**
 * 提交数据
 * @param entities
 * @param vm
 * @returns {Promise}
 */
async function save(entities, vm) {
  entities.keyWordsId = vm.keyId || 0
  return await dataApi.saveFormDetail(entities);
}


/**
 * 表单组件
 */
export default {
  mixins: [formMixin],
  components: {
    // roleTable,
    // roleTableModal
  },
  computed: {
    ...mapState('account', {currUser: 'user'}),
  },
  data() {
    return {
      show: false,
      weichatTagGroupId: "",
      weichatTagId: "",
      editStatus: false,
      treeData: [],
      dealer: [],
      tagType: [{title: '企微标签', value: 1}, {title: 'SCRM标签', value: 2}],
    }
  },
  methods: {
    loadEntity,
    newEntity,
    save,
    getRulesTemplate,
    loadBaseData,
    afterLoad,
    changeType(val) {
      if (val === 1) {
        this.rules.weichatTagGroupName.rules[0].required = true
      } else {
        this.rules.weichatTagGroupName.rules[0].required = false
      }
    }
  },
};
</script>

<style scoped lang="less">
</style>